<template>
  <!-- The play mode, switched on the game page itself (SPEC §4.6); the other settings are on the
       settings page. Labelled like the settings page's button, but small and plain: it is a
       convenience, not one of the game's controls (owner, 2026-10-13). -->
  <button type="button" class="play-mode" @click="toggle">落子方式: {{ mode === 'quick' ? '快速' : '按钮' }}</button>
</template>

<script>
export default {
  name: 'PlayModeToggle',

  computed: {
    mode() {
      return (this.$store.state.ui && this.$store.state.ui.playMode) || 'button';
    },
  },

  methods: {
    toggle() {
      this.$store.commit('set', { ui: { playMode: this.mode === 'quick' ? 'button' : 'quick' } });
      localStorage.setItem('ui', JSON.stringify(this.$store.state.ui));
    },
  },
}
</script>

<style scoped>
.play-mode {
  display: block;
  margin: 6px auto 0;
  padding: 2px 4px;
  border: none;
  background: none;
  color: #999;
  font-size: 12px;
  cursor: pointer;
}

.play-mode:hover {
  color: #595959;
  text-decoration: underline;
}
</style>
